import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from '../../../core/service/auth/authentication.service';
import { LocalStorageService } from '../../../core/service/localStorage/local-storage.service';

@Component({
  selector: 'app-email-reset-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    RouterModule
  ],
  templateUrl: './email-reset-password.component.html',
  styleUrl: './email-reset-password.component.scss'
})
export class EmailResetPasswordComponent implements OnInit {
  resetPasswordForm!: FormGroup;
  hideNewPassword = true;
  hideConfirmPassword = true;
  brandLogo = './assets/images/logo.svg';
  token: string | null = null;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params['code'] || params['token'];
      
      // If token exists, we can temporarily set it for the API call to work if interceptors depend on it
      if (this.token) {
        this.localStorageService.setKey('access_token', this.token);
      }
    });

    this.resetPasswordForm = this.fb.group({
      newPassword: ['', [
        Validators.required, 
        Validators.minLength(8), 
        Validators.maxLength(20),
        Validators.pattern(/(?=.*[A-Z])(?=.*[^a-zA-Z0-9])/)
      ]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordMatchValidator });
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('newPassword')?.value === g.get('confirmPassword')?.value
      ? null : { mismatch: true };
  }

  onSubmit(): void {
    if (this.resetPasswordForm.valid && this.token) {
      this.isLoading = true;
      this.errorMessage = null;
      this.successMessage = null;

      const { newPassword, confirmPassword } = this.resetPasswordForm.value;

      this.authService.resetPassword(confirmPassword, newPassword).subscribe({
        next: (res) => {
          this.isLoading = false;
          this.successMessage = 'Password reset successfully. You can now login.';
          // Clear token
          this.localStorageService.removeKey('access_token');
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 3000);
        },
        error: (err) => {
          this.isLoading = false;
          this.errorMessage = err?.error?.message || 'Failed to reset password. Please try again.';
        }
      });
    } else if (!this.token) {
      this.errorMessage = 'Invalid or missing reset token.';
    }
  }
}
